export default __webpack_public_path__ + "static/media/about-banner.cd5f8a64.png";